// src/components/HomePage.tsx
import React, { useState, useEffect } from 'react';
import './Accueil.css';
import devImage from '../Images/accueil.png';

interface HomePageProps {
    language: 'en' | 'fr';
}

interface Message {
    text: string;
    fontClass: string; // "large" ou "very-small"
}

// Définition des messages pour chaque langue
const messages: { en: Message[]; fr: Message[] } = {
    en: [
        { text: "Hello, I'm Julien", fontClass: "large" },
        { text: "Computer Science Student", fontClass: "very-small" },
    ],
    fr: [
        { text: "Bonjour, je suis Julien", fontClass: "large" },
        { text: "Étudiant en informatique", fontClass: "very-small" },
    ],
};

function highlightText(text: string, word: string): string {
    const regex = new RegExp(`(${word})`, 'gi');
    return text.replace(regex, `<span class="highlight">$1</span>`);
}

const HomePage: React.FC<HomePageProps> = ({ language }) => {
    const speed = 100;
    const delayBetween = 1000;

    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [offset, setOffset] = useState(0);
    const [typedMessages, setTypedMessages] = useState<string[]>(["", ""]);

    const currentMessages = messages[language];

    // Réinitialisation de l'animation lors du changement de langue
    useEffect(() => {
        setCurrentMessageIndex(0);
        setOffset(0);
        setTypedMessages(["", ""]);
    }, [language]);

    useEffect(() => {
        if (currentMessageIndex < currentMessages.length) {
            const currentMessage = currentMessages[currentMessageIndex].text;
            if (offset < currentMessage.length) {
                const timeout = setTimeout(() => {
                    setOffset(offset + 1);
                    setTypedMessages(prev => {
                        const newTyped = [...prev];
                        newTyped[currentMessageIndex] = currentMessage.substring(0, offset + 1);
                        return newTyped;
                    });
                }, speed);
                return () => clearTimeout(timeout);
            } else {
                const timeout = setTimeout(() => {
                    setCurrentMessageIndex(currentMessageIndex + 1);
                    setOffset(0);
                }, delayBetween);
                return () => clearTimeout(timeout);
            }
        }
    }, [offset, currentMessageIndex, currentMessages]);

    const highlightedMessage = (index: number) => {
        let text = typedMessages[index] || "";
        if (index === 0) {
            text = highlightText(text, language === 'en' ? "Hello" : "Bonjour");
        } else if (index === 1) {
            text = highlightText(text, language === 'en' ? "Student" : "informatique");
        }
        return text;
    };

    return (
        <div className="home-container">
            <div className="home-left">
                <h1
                    className={`welcome-text ${currentMessages[0].fontClass}`}
                    dangerouslySetInnerHTML={{ __html: highlightedMessage(0) }}
                />
                <h2
                    className={`welcome-text ${currentMessages[1].fontClass}`}
                    dangerouslySetInnerHTML={{ __html: highlightedMessage(1) }}
                />
                <a href="/CV.pdf" download className="cv-button">
                    {language === 'en' ? "Download my CV" : "Télécharger mon CV"}
                </a>

            </div>
            <div className="home-right">
                <img src={devImage} alt="Developer" className="home-image" />
            </div>
        </div>
    );
};

export default HomePage;
